import {TypographyVariant} from "./types";

export const fontSizeObj: {[V in TypographyVariant]: number} = {
  title: 20,
  normal: 15,
  subtitle: 18,
};
